export default "<p>delegate-invitation-sent works!</p>\r\n";